import { render, staticRenderFns } from "./ComplaintHistory.vue?vue&type=template&id=7f31989c&"
import script from "./ComplaintHistory.vue?vue&type=script&lang=js&"
export * from "./ComplaintHistory.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports